import { lazy } from "react";
import { Navigate } from "react-router-dom";

import BusinessIcon from "@mui/icons-material/Business";

const OrganizationList = lazy(() => import("../components/orgList"));
const Organization = lazy(() => import("../components/organization"));
const OrganizationEditView = lazy(() => import("../components/organizationEditView"));

const administratorRoute =
  // {
  //   icon: BusinessIcon,
  //   name: "Organization Management",
  //   link: "/organization-management",
  //   path: "organization-management",
  //   index: 3,
  //   element: "",
  //   children:
  [
    {
      path: "organizations",
      element: <OrganizationList />,
      name: "Organizations",
      link: "/organizations",
      icon: BusinessIcon,
      index: 0,
      permission: "Organizations-Read",
    },
    {
      path: "organizations/create",
      element: <Organization />,
    },
    {
      path: "organizations/:id",
      element: <OrganizationEditView />,
    },
    {
      path: "",
      element: <Navigate to="organizations" replace />,
    },
  ];
// };
export default administratorRoute;
